import Vue from "vue/dist/vue.esm";

export default function init() {
  const elements = document.querySelectorAll(".modalOverlay");

  if (elements) {
    elements.forEach(element => {
      new Vue({
        el: `#${element.id}`,
        data: {
          isVideo: true,
          modalActive: false,
          htmlElement: null,
          dictionary: window.dictionary,
          consentGiven: window.Cookiebot.consent.marketing
        },
        methods: {
          handleContentButton() {
            window.Cookiebot.onaccept = () => {
              this.consentGiven = window.Cookiebot.consent.marketing;
              this.checkConsent();
            };
            window.Cookiebot.show();
          },
          checkConsent() {
            const iframe = this.$refs.modalContent.querySelector("iframe");

            if (iframe && this.isVideo) {
              if (this.consentGiven && this.modalActive) {
                if (!iframe.src) {
                  iframe.src = iframe.getAttribute("data-src");
                  iframe.removeAttribute("data-src");
                }
              } else {
                if (iframe.src) {
                  iframe.setAttribute("data-src", iframe.src);
                  iframe.removeAttribute("src");
                }
              }
            }
          },
          openModal() {
            this.modalActive = true;
            this.htmlElement.classList.add("is-clipped");
          },
          closeModal() {
            this.modalActive = false;
            this.htmlElement.classList.remove("is-clipped");
            if (this.isVideo) {
              this.$refs.modalContent
                .querySelector("iframe")
                .contentWindow.postMessage(
                  '{"event":"command","func":"stopVideo","args":""}',
                  "*"
                );
            }
          },
          internallyCloseModal() {
            this.closeModal();
            this.$emit("closeModal");
          },
          escCloseModal(event) {
            if (event.keyCode === 27) {
              this.internallyCloseModal();
            }
          }
        },
        watch: {
          isModalOpen: function(newValue, oldValue) {
            if (newValue !== oldValue) {
              newValue === true ? this.openModal() : this.closeModal();
            }
          },
          modalActive: function() {
            this.consentGiven = window.Cookiebot.consent.marketing;
            window.setTimeout(this.checkConsent, 20);
          }
        },
        mounted() {
          window.addEventListener("keyup", this.escCloseModal);
          this.htmlElement = document.querySelector("html");
        },
        destroyed() {
          window.removeEventListener("keyup", this.escCloseModal);
        }
      });
    });
  }
}
